import { render, staticRenderFns } from "./Lokasi.vue?vue&type=template&id=71349414&scoped=true&"
import script from "./Lokasi.vue?vue&type=script&lang=js&"
export * from "./Lokasi.vue?vue&type=script&lang=js&"
import style0 from "./Lokasi.vue?vue&type=style&index=0&id=71349414&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71349414",
  null
  
)

export default component.exports